import { render, staticRenderFns } from "./modificarServiciosView.vue?vue&type=template&id=ff5f9e46&scoped=true&"
import script from "./modificarServiciosView.vue?vue&type=script&lang=js&"
export * from "./modificarServiciosView.vue?vue&type=script&lang=js&"
import style0 from "./modificarServiciosView.vue?vue&type=style&index=0&id=ff5f9e46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5f9e46",
  null
  
)

export default component.exports